export default {"src":"/_next/static/media/discovery.587b6348.svg","height":79,"width":61};